module.exports = __webpack_public_path__ + "static/img/jersey2020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jersey2020.jpg
// module id = A3j0
// module chunks = 0